"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("@chakra-ui/react");
var _reactHookForm = require("react-hook-form");
var _jsxRuntime = require("react/jsx-runtime");
const ContextModal = props => {
  const {
    register,
    handleSubmit,
    watch,
    formState: {
      errors,
      isSubmitting
    }
  } = (0, _reactHookForm.useForm)({
    defaultValues: {
      input: props.inputText
    }
  });
  const onSubmit = data => {
    props.onFinish(data.input);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Modal, {
      isOpen: props.isOpen,
      onClose: props.onClose,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.ModalOverlay, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.ModalContent, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("form", {
          onSubmit: handleSubmit(onSubmit),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.ModalHeader, {
            children: [props.title, " test"]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.ModalCloseButton, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.ModalBody, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.FormControl, {
              isInvalid: !!errors.input,
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Input, {
                placeholder: props.inputPlaceholder,
                ...register('input', {
                  required: 'Input is required'
                })
              }), errors.input && /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.FormErrorMessage, {
                children: errors.input.message
              })]
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.ModalFooter, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Button, {
              colorScheme: "blue",
              mr: 3,
              type: "submit",
              isLoading: isSubmitting,
              children: props.finishBtnLabel || 'Save'
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Button, {
              onClick: props.onCancel,
              type: "reset",
              children: props.cancelBtnLabel || 'Cancel'
            })]
          })]
        })
      })]
    })
  });
};
var _default = ContextModal;
exports.default = _default;